module.exports = __webpack_public_path__ + "media/images/calendar-c486c8ec.png";